import React from 'react';
import { Link } from 'react-router-dom';
import { User } from '../../types/kyb';

interface HeaderProps {
  title?: string;
  user: User;
}

const Header: React.FC<HeaderProps> = ({ title, user }) => {
  return (
    <header className="h-16 bg-white border-b border-neutral-200 shadow-button flex items-center justify-between px-8">
      <div className="flex items-center">
        <Link to="/" className="flex items-center">
          <div className="flex items-center mr-2 bg-primary-500 text-white px-2 py-1 rounded">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <span className="font-bold text-lg tracking-tight">BYNN</span>
          </div>
          <div className="text-lg font-semibold text-primary-600 tracking-tight">KYB</div>
        </Link>
        
        {title && (
          <>
            <div className="mx-4 text-neutral-300">|</div>
            <h1 className="text-lg font-medium text-neutral-800">{title}</h1>
          </>
        )}
      </div>
      
      <div className="flex items-center space-x-6">
        <nav className="hidden md:flex space-x-6">
          <a href="#" className="text-sm font-medium text-neutral-600 hover:text-primary-600 transition-colors">Dashboard</a>
          <a href="#" className="text-sm font-medium text-neutral-600 hover:text-primary-600 transition-colors">Documents</a>
          <a href="#" className="text-sm font-medium text-neutral-600 hover:text-primary-600 transition-colors">Support</a>
        </nav>
        
        <div className="flex items-center space-x-4">
          <div className="relative">
            <button className="p-1.5 rounded-full bg-neutral-100 hover:bg-neutral-200 transition-colors">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-5 w-5 text-neutral-600" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" 
                />
              </svg>
            </button>
            {user.notifications > 0 && (
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-primary-500 rounded-full flex items-center justify-center border border-white">
                <span className="text-white text-xs font-medium">{user.notifications}</span>
              </div>
            )}
          </div>
          
          <div className="flex items-center">
            <button className="flex items-center space-x-2 group">
              <div className="w-8 h-8 bg-primary-100 rounded-full overflow-hidden border-2 border-white shadow-sm">
                <img 
                  src={user.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=1A73E8&color=fff`} 
                  alt={`${user.name}'s avatar`}
                />
              </div>
              <div className="hidden md:block">
                <div className="text-sm font-medium text-neutral-800 group-hover:text-primary-600">{user.name}</div>
                <div className="text-xs text-neutral-500">{user.role}</div>
              </div>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-5 w-5 text-neutral-400 group-hover:text-primary-500" 
                viewBox="0 0 20 20" 
                fill="currentColor"
              >
                <path 
                  fillRule="evenodd" 
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
                  clipRule="evenodd" 
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;